import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@wds/box';
import { Badge } from '@wds/badge';
import { Button } from '@wds/button';
import { Typography } from '@wds/typography';
import docusignLogo from './docusign-logo.svg';

const ExternalLinkIcon = () => (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' aria-hidden='true'>
        <path
            d='M6.5 3H3.75a.75.75 0 0 0-.75.75v8.5c0 .414.336.75.75.75h8.5a.75.75 0 0 0 .75-.75V10'
            stroke='currentColor'
            strokeWidth='1.3'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M9 3h4v4M13 3 7 9'
            stroke='currentColor'
            strokeWidth='1.3'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

const LockIcon = () => (
    <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
        <rect x='3' y='11' width='18' height='11' rx='2' ry='2' />
        <path d='M7 11V7a5 5 0 0 1 10 0v4' />
    </svg>
);

const DocuSignDashboardPromoCard = ({ connectUrl, isPlanBelowLimit, upgradeUrl }) => {
    
    // Renders the upgrade layout for verification
    if (isPlanBelowLimit) {
        return (
            <>
                <Box
                    className='docusign-dashboard-promo-card-upgrade'
                    style={{
                        backgroundColor: '#FEF2CC',
                        borderRadius: '2px',
                        marginTop: '1em'
                    }}
                    p={3}
                    display='flex'
                    flexDirection='row'
                    alignItems='center'
                    gap={3}
                >
                    <img src={docusignLogo} alt='' height={22} />
                    <Box display='flex' flexDirection='column' style={{ flex: 1 }}>
                        <Box display='flex' flexDirection='row' alignItems='center' gap={2} mb={1}>
                            <Typography variant='body' weight='bold' component='span'>
                                {gettext('Introducing Docusign')}
                            </Typography>
                            <Badge color='success' size='sm' style={{ backgroundColor: '#A7F3D0', color: '#065F46' }}>
                                {gettext('New')}
                            </Badge>
                        </Box>
                        <Typography variant='body' style={{ color: '#555' }}>
                            {gettext('Collect signatures on your forms without any extra back-and-forth.')}
                        </Typography>
                    </Box>
                    <Button color='upgrade' href={upgradeUrl || '#'}>
                        <LockIcon />
                        <span style={{ display: 'inline-block', width: 6 }} />
                        {gettext('Upgrade')}
                    </Button>
                </Box>
            </>
        );
    }

    // Original layout
    return (
        <Box
            className='docusign-dashboard-promo-card'
            style={{
                backgroundColor: '#E5F9F1',
                borderRadius: '2px',
                marginTop: '1em'
            }}
            p={3}
            display='flex'
            flexDirection='row'
            alignItems='center'
            gap={2}
        >
            <img src={docusignLogo} alt='' height={22} />
            <Box display='flex' flexDirection='column' style={{ flex: 1 }}>
                <Box display='flex' flexDirection='row' alignItems='center' gap={2} mb={1}>
                    <Typography variant='body' weight='medium' component='span'>
                        {gettext('Introducing Docusign')}
                    </Typography>
                    <Badge color='success' size='sm'>{gettext('New')}</Badge>
                </Box>
                <Typography variant='body'>
                    {gettext('Collect signatures on your forms without any extra back-and-forth.')}
                </Typography>
            </Box>
            <Button color='primary' href={connectUrl}>
                {gettext('Connect to docusign')}
                <span style={{ display: 'inline-block', width: 10 }} />
                <ExternalLinkIcon />
            </Button>
        </Box>
    );
};

DocuSignDashboardPromoCard.propTypes = { 
    connectUrl: PropTypes.string,
    upgradeUrl: PropTypes.string,
    isPlanBelowLimit: PropTypes.bool
};

DocuSignDashboardPromoCard.defaultProps = {
    isPlanBelowLimit: false
};

export default DocuSignDashboardPromoCard;